import { Component,Inject,ViewChild } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig,MatLegacyDialogRef as MatDialogRef,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { firstValueFrom } from "rxjs";
import { filter } from "rxjs/operators";
import { FileEntity } from '../../dave-data-module/entities/file.entity';
import { VersionEntity } from '../../dave-data-module/entities/version.entity';
import { PdfEditorLegacyComponent } from '../../dave-dms-module/dave-dms/pdf-editor-legacy/components/pdf-editor-legacy.component';
import { PdfEditorComponent } from '../../dave-dms-module/dave-dms/pdf-editor/pdf-editor.component';
import { appMatDialogDefaultConfig } from '../../helper/helper';

export const FullscreenDialogComponentConfig: MatDialogConfig = {
    ...appMatDialogDefaultConfig,
    height: '100%',
    width: '100%',
    panelClass: [...appMatDialogDefaultConfig.panelClass,'custom-dialog-class-without-padding', 'custom-dialog-class-mobile-fullscreen', 'custom-dialog-class-tablet-fullscreen', 'no-header'],
    disableClose: true,
};
export interface FullscreenDialogData {
    file: FileEntity;
    version: VersionEntity;
    /**
     * works only with pdf files
     */
    signingMode?: boolean;
    setCheckedButton?: boolean;
}

@Component({
    selector: 'app-fullscreen-dialog',
    template: `
        <button class="right-bottom" app-round-button (click)="Close()" matTooltip="Schließen" *ngIf="Data.file.MIMEType.indexOf('application/pdf') > -1">
            <fa-icon icon="compress"></fa-icon>
        </button>
        <button mat-icon-button (click)="Close()" class="close-mat-dialog-button" matTooltip="Schließen" style="z-index: 10000;" *ngIf="Data.file.MIMEType.indexOf('image/') > -1">
            <fa-icon icon="times" size="2x"></fa-icon>
        </button>
        <app-image-editor *ngIf="Data.file.MIMEType.indexOf('image/jpeg') > -1 || Data.file.MIMEType.indexOf('image/png') > -1 " [File]="Data.file" [Version]="Data.version"></app-image-editor>
        <app-pdf-editor #pdfEditor  [SigningMode]="Data.signingMode" *ngIf="Data.file.MIMEType.indexOf('application/pdf') > -1" [Version]="Data.version" [SetCheckedButtonDocumentId]="Data.file.Id"></app-pdf-editor>
    `,
    styleUrls: ['./fullscreen-dialog.component.scss'],
})
export class FullscreenDialogComponent {
    // @ViewChild('pdfEditor') PdfEditor: PdfEditorLegacyComponent;
    public static readonly DefaultConfig: MatDialogConfig = FullscreenDialogComponentConfig;
    // @ViewChild('pdfEditor') PdfEditor: PdfEditorLegacyComponent;
    @ViewChild('pdfEditor') PdfEditor: PdfEditorComponent;
    constructor(@Inject(MAT_DIALOG_DATA) public Data: FullscreenDialogData, public DialogRef: MatDialogRef<FullscreenDialogComponent>) {
        console.warn('+++');
        console.log(Data)
    }
    public async Close() {
        if (this.PdfEditor) {
            await firstValueFrom(this.PdfEditor.LS.IsLoading$.pipe(filter((loading) => !loading)));
            const canLeave = this.PdfEditor.canDeactivate();

            if (!canLeave && confirm('Möchten Sie die Änderungen speichern ?')) {
                await this.PdfEditor.Save();
                await firstValueFrom(this.PdfEditor.LS.IsLoading$.pipe(filter((loading) => !loading)));
            }

            await this.PdfEditor?.Close();
        }
        this.DialogRef.close();
    }
}
